import React from 'react';
import { Linking, Platform, StyleSheet, View } from 'react-native';
import { ErrorCode } from 'utils/packages/iap';
import { openSettings } from 'utils/packages/intentLauncher';
import Button from 'design-system/Button';
import { ButtonGroup } from 'design-system/ButtonGroup';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { Spacer } from 'design-system';
const PurchaseErrorModalContent = ({ error, onPressTryAgain, }) => {
    const navigation = useMainStackNavigation();
    const onPressSupport = () => {
        Modal.hide(() => {
            navigation.navigateDeprecated('Support', {});
        });
    };
    const onPressBillingSettings = () => {
        if (Platform.OS === 'ios') {
            Linking.openURL('https://apps.apple.com/account/billing');
        }
        else if (Platform.OS === 'android') {
            Linking.openURL('https://play.google.com/store/paymentmethods');
        }
    };
    const onPressNetworkSettings = () => {
        if (Platform.OS === 'ios') {
            Linking.openURL('App-Prefs:root=WIFI');
        }
        else if (Platform.OS === 'android') {
            openSettings('android.settings.SETTINGS');
        }
    };
    return (<View>
      <Text TextThin-14 Secondary centered style={styles.text}>
        The purchase could not be completed, you have not been charged.
      </Text>
      <Spacer h={10}/>
      <Text TextThin-14 Secondary centered>
        {error.message}
      </Text>
      <Spacer h={24}/>
      <ButtonGroup margins={false}>
        <Button title="Chat with support" onPress={onPressSupport} gray/>
        {error.code === ErrorCode.UserError && (<Button title="Payment settings" onPress={onPressBillingSettings} brandReversed/>)}
        {(error.code === ErrorCode.NetworkError ||
            (Platform.OS === 'android' &&
                error.code === ErrorCode.ServiceError)) && (<Button title="Network settings" onPress={onPressNetworkSettings} brandReversed/>)}
        {onPressTryAgain !== undefined && (<Button title="Try again" onPress={onPressTryAgain} brand/>)}
      </ButtonGroup>
    </View>);
};
const styles = StyleSheet.create({
    text: {
        marginTop: rem(16),
    },
});
export default PurchaseErrorModalContent;
